import React, { Component } from 'react';
import Header from '../header';
import MetaTags from 'react-meta-tags';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Questions from './views/questions';
import * as DataStatic from '../../api/homeDataStatic';
import Footer from '../footer';
import RaisedButton from 'material-ui/RaisedButton';
import './style.scss';
// https://css-tricks.com/aos-css-driven-scroll-animation-library/
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css'; 

import arenalImg from "../common/arenal-volcano-1463562.jpg";
import macawImg from "../common/scarlet-macaw.jpg";

export default class AboutPageController extends Component {
    constructor(props){
        super(props);
        console.log(props);
        this.handleClick = this.handleClick.bind();
        AOS.init();
    }

    componentWillReceiveProps (){ 
        AOS.refresh(); 
    } 

    componentDidMount(){
        // let pageName = this.props.match.params.name;
    }

    handleClick = () => {
        console.log( this )
        this.props.history.push("/build-your-team");
    }

    render(){
        const styles = {
            backgroundImage: `url(${arenalImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition:'center'
        }
        const stylesMacaw = {
            backgroundImage: `url(${macawImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition:'center'
        }
        const styleGrid = {
            width: "61.25rem",
            margin: " 100px auto"
        }
        return(
            <div key={`page-about`}>
                <MetaTags>
                    <title>{`App2soft | About Us`}</title>
                    <meta name="description" content="" />
                    <meta name="keywords" content="" />
                    <meta name="author" content="Upway Solutions" />
                    <meta property="og:image" content={`${logo}`} />
                </MetaTags>
                <Header animation={false}/>
                <section className="page-about">
                    <div className="page-title" style={styles}>
                        <div className="title" data-aos="fade-down"> 
                            <h2 data-aos="fade-up">About Us</h2>
                            <p>We are a custom software development firm achieving rapid delivery cycles, stable, test-driven software, and streamlined IT processes since 2008. Located in Costa Rica, the heart of Latin America, we provide assistance to US companies in the creation of their own nearshore software development team.</p>
                            <p>Getting the best developers of the country in a similar US time zone with a cost-effective performance is what we guarantee to each of our clients.</p>
                        </div>
                    </div>
                    <div className="main" data-aos="fade-down">
                        <div style={stylesMacaw}></div>
                        <div data-aos="fade-up">
                            <h2>Political Stability</h2>
                            <p>Costa Rica a strong democratic country that abolished its 
                                army since 1949 to invest the national defense budget to 
                                education. Leading as the most prosperous country in 
                                Central America and one of the most developed in all 
                                Latin America the country has become one of the highest 
                                standards of living and one with the lowest levels of 
                                poverty.
                            </p>
                            <h2>Sustainability</h2>
                            <p>Costa Rica is currently known to be a worldwide leader in 
                                sustainability with its 93% of renewable energy and on 
                                it’s way to permanently be the number one nation 
                                worldwide with 100 percent in this ecological balance. 
                                This small country also houses a 5% of the planet’s 
                                biodiversity. With these facts just imagine having an 
                                extension of your office with rainforest and beautiful 
                                beaches all around.
                            </p>
                        </div>
                    </div>
                    <div className="related-videos" data-aos="fade-down">
                        <h2>Related Videos</h2>
                        <div className="main">
                            <div className="item">
                            <iframe width="100%" height="200" src="https://www.youtube.com/embed/pNTirQ9eoLo?ecver=1" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                                <h3>Essential Costa Rica</h3>
                            </div>
                            <div className="item">
                                <iframe width="100%" height="200" src="https://www.youtube.com/embed/QbhCpfxsod8?ecver=1" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                                <h3>ICT Costa Rica Tourism, Save the Americans/Canadians</h3>
                            </div>
                            <div className="item">
                                <iframe width="100%" height="200" src="https://www.youtube.com/embed/JpruLHD4vFI" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                                <h3>How much do you know about Costa Rica?</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="questions" data-aos="fade-up">
                    <h2>Build your online team</h2>
                    <RaisedButton label="Get Started" primary={true} onClick={ this.handleClick }/>
                </div>
                <Footer />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/about_page/index.js